module.exports = __webpack_public_path__ + "img/deleteSuccess.443b360d.png";